import React from "react";
import { useState, useEffect } from "react";

import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// import optional lightbox plugins
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

//Importing images from api & Breakpoints//
import instance from "../../services/ApiServices";

// import photos from "../views/Photos";
// import photos from "../views/MyPhotos";
// // import MyPhoto  from "../views/MyPhotos";

const Gallery = () => {
  const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];
  const [index, setIndex] = useState(-1);
  const endpoint = "gallery";

  const [allphoto, setAllphoto] = useState([]);

  useEffect(() => {
    instance.get(endpoint).then((res) => {
      const datarcd = res.data;
      const galleryitems = [];
      datarcd.forEach((data) => {
        const asset = data["image"];
        const width = data["width"];
        const height = data["height"];
        const alt = data["name"];
        galleryitems.push({
          asset: asset,
          width: width,
          height: height,
          alt: alt,
        });
      });

      // console.log("My Image:" + JSON.stringify(datarcd));
      setAllphoto(galleryitems);
      // console.log("Gallery Items :"+JSON.stringify(galleryitems));
    });
  }, []);

  // Transforming images to display on gallery
  const photos = allphoto.map(({ asset, alt, width, height }) => ({
    src: asset,
    alt,
    width,
    height,
    srcSet: breakpoints.map((breakpoint) => ({
      src: asset,
      width: breakpoint,
      height: Math.round((height / width) * breakpoint),
    })),
  }));

  return (
    <>
      <div className="container py-10">
        <div>
          <RowsPhotoAlbum
            photos={photos}
            targetRowHeight={200}
            onClick={({ index }) => setIndex(index)}
          />

          <Lightbox
            slides={photos}
            open={index >= 0}
            index={index}
            close={() => setIndex(-1)}
            // enable optional lightbox plugins
            plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
          />
        </div>
      </div>
    </>
  );
};

export default Gallery;
